import SectionTitle from '@/components/common/SectionTitle';
import { Container, Typography } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import CategoryPageContext from '@/context/CategoryPageContext';
import { IAlumniCompanies } from '@/interfaces/categoryPage';
import BoastingCards from './BoastingCards';
import cardsMeta from './constants';
import CompanyCard from './CompanyCard';
import DownloadReport from './DownloadReport';

const ProudAlumni = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const alumni = categoryDetails?.alumni;
  const cardData = {
    learnersPlaced: alumni?.learnersPlaced as string,
    highestSalary: alumni?.highestSalary as string,
    industryExpert: alumni?.industryExpert as string,
    hiringPartners: alumni?.hiringPartners as string,
  };

  return (
    <Container className="medium:!px-8 large:!px-20  py-8 medium:py-14 ">
      <div>
        <SectionTitle upperText="We are proud" lowerText={`Our Alumni's`} />
        <Typography
          component="body-small"
          variant="regular"
          className="text-gray-650 mt-3 medium:!hidden"
        >
          Unleashing Expertise That Delivers : A Record of Excellence
        </Typography>
      </div>
      <div className="flex flex-row flex-wrap gap-6 justify-center medium:flex-nowrap medium:gap-4 mt-6 medium:!mt-8  rounded-[12px] medium:px-[100px]">
        {cardsMeta?.map((card) => (
          <BoastingCards cardData={cardData} {...card} />
        ))}
      </div>
      <div className="flex flex-row justify-center medium:!hidden mt-6">
        <Typography component="body-regular" variant="bold">
          Our Alumni Are Placed At
        </Typography>
      </div>

      <div className="w-full flex flex-row flex-wrap gap-4 large:!gap-3 mt-6 justify-center ">
        {alumni?.companies?.map((company: IAlumniCompanies) => (
          <CompanyCard {...company} />
        ))}
      </div>

      {alumni?.report && <DownloadReport reportLink={alumni?.report as string} />}
    </Container>
  );
};

export default ProudAlumni;
